const cards = [
  {
    title: '暑期追剧必看片单',
    desc: '精心整理20部暑期必追热播剧集，从古装到现代，从悬疑到治愈，陪你度过精彩一夏。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20summer%20reading%20nook%20aesthetic%20with%20soft%20golden%20sunlight%2C%20cozy%20atmosphere%2C%20minimal%20decor%2C%20warm%20amber%20and%20cream%20tones%2C%20relaxed%20vibe%2C%20no%20people%2C%20peaceful%20and%20inviting&width=600&height=400&seq=wuma-card-01&orientation=landscape',
    tag: '片单推荐',
    date: '7月31日',
  },
  {
    title: '2026上半年豆瓣高分剧',
    desc: '盘点2026上半年豆瓣评分8分以上的优质国产剧，品质保证，每一部都值得反复品味。',
    image: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20editorial%20flat%20lay%20with%20golden%20accents%2C%20warm%20lighting%2C%20elegant%20minimal%20composition%2C%20premium%20feel%2C%20no%20people%2C%20curated%20review%20aesthetic&width=600&height=400&seq=wuma-card-02&orientation=landscape',
    tag: '高分盘点',
    date: '7月28日',
  },
  {
    title: '古装剧服化道大赏',
    desc: '深扒近期热播古装剧中的惊艳服化道设计，从发饰到布景，每一处都是视觉享受。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20textile%20and%20silk%20fabric%20in%20warm%20rich%20colors%2C%20intricate%20patterns%2C%20soft%20dramatic%20lighting%2C%20historical%20costume%20detail%20aesthetic%2C%20no%20people%2C%20luxurious%20texture&width=600&height=400&seq=wuma-card-03&orientation=landscape',
    tag: '深度解析',
    date: '7月25日',
  },
  {
    title: '悬疑剧迷入门指南',
    desc: '从入门到进阶，为你推荐不同难度的悬疑刑侦剧，层层递进的烧脑体验从这里开始。',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20dark%20study%20room%20with%20warm%20desk%20lamp%20light%2C%20shadows%2C%20books%2C%20magnifying%20glass%2C%20detective%20aesthetic%2C%20no%20people%2C%20noir%20moody%20atmosphere&width=600&height=400&seq=wuma-card-04&orientation=landscape',
    tag: '追剧指南',
    date: '7月22日',
  },
  {
    title: '韩剧入坑必看清单',
    desc: '精选15部口碑与热度兼具的韩剧作品，从经典到新作，总有一部让你欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20modern%20Korean%20cafe%20interior%20with%20warm%20cozy%20lighting%2C%20minimal%20design%2C%20soft%20shadows%2C%20contemporary%20aesthetic%2C%20no%20people%2C%20inviting%20atmosphere&width=600&height=400&seq=wuma-card-05&orientation=landscape',
    tag: '韩剧推荐',
    date: '7月20日',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            精选剧集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精心策划的追剧内容，从片单推荐到深度解析，助你发现更多好剧
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((item, index) => (
            <div
              key={index}
              className={`group rounded-2xl overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-all cursor-pointer ${
                index === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${index === 0 ? 'aspect-[2/1]' : 'aspect-[3/2]'}`}>
                <img
                  src={item.image}
                  alt={`午马影院 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[10px] md:text-xs font-medium text-primary-500 bg-background-50/90 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 flex-1 mr-2">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}